import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Accordion from "react-bootstrap/Accordion";

export default function FAQ() {
  const generalQuestions = [
    {
      id: "g1",
      q: "How does the concept process look like ?",
      a: "At TSM Pvt. Ltd, our concept process starts with understanding your business needs, followed by research and idea development. We then create initial concepts and share them with you for feedback. After refining the plan together, we move into development, testing, and quality assurance. Finally, we launch the solution and provide ongoing support, ensuring a smooth and successful project from start to finish. Understanding Your Needs, Research & Analysis, Concept Development, Client Review & Feedback, Planning & Strategy, Execution, Testing & Quality Assurance, Launch & Support",
    },

    {
      id: "g2",
      q: "What are the market research approaches ?",
      a: "Primary Research: Gathering new data directly from sources through surveys, interviews, focus groups, and observations. This helps obtain firsthand insights specific to your business needs. Secondary Research: Analyzing existing data from reports, studies, government publications, industry databases, and competitor information. It’s useful for understanding broader market trends. Qualitative Research: Exploring customer motivations, opinions, and behaviors through open-ended methods like interviews and focus groups to gain in-depth understanding. Quantitative Research: Collecting numerical data via surveys or polls to identify patterns, measure market size, and analyze consumer preferences statistically. Competitive Analysis: Studying competitors’ products, pricing, marketing strategies, and customer feedback to identify opportunities and threats. Trend Analysis: Monitoring industry developments, emerging technologies, and consumer behavior hanges to anticipate market shifts.",
    },

    {
      id: "g3",
      q: "How long term partnership look like ?",
      a: "A long-term partnership with TSM Pvt. Ltd means more than just delivering projects — it’s about building trust, understanding your evolving business needs, and growing together. We work closely with you to provide continuous support, regular updates, and proactive solutions that keep your technology aligned with market changes. Our team acts as an extension of your business, offering strategic advice, innovation, and reliable maintenance to help you stay competitive over time. Through open communication and collaboration, we ensure that the partnership delivers sustained value, flexibility, and mutual success.",
    },

    {
      id: "g4",
      q: "Do you share insights regularly ?",
      a: "Yes, at TSM Pvt. Ltd, we believe that transparent and ongoing communication is key to a successful partnership. We provide regular insights through detailed progress reports, analytics dashboards, and review meetings. These updates help you stay informed about project milestones, performance metrics, and opportunities for improvement. By sharing timely and actionable insights, we ensure that you can make well-informed decisions and continuously optimize your technology solutions.",
    },

    {
      id: "g5",
      q: "Do we get dedicated account manager ?",
      a: "Yes, at TSM Pvt. Ltd, every client is assigned a dedicated account manager who acts as your primary point of contact. Your account manager ensures smooth communication, understands your business needs deeply, and coordinates with our technical team to deliver timely and personalized solutions. This helps provide you with focused support, quick responses, and a seamless project experience from start to finish.",
    },
  ];

  const privacyQuestions = [
    {
      id: "p1",
      q: "How is my data secured?",
      a: "We implement robust security measures, encryption, and access controls to ensure your data remains protected at all times.",
    },
    {
      id: "p2",
      q: "Do you provide self-hosted servers?",
      a: "Yes, we offer dedicated self-hosted server solutions, giving you complete control over your infrastructure and data.",
    },
    {
      id: "p3",
      q: "Do you offer private cloud solutions?",
      a: "Yes, our self-cloud solutions provide scalable, secure, and fully managed cloud environments tailored to your needs.",
    },
    {
      id: "p4",
      q: "Is data backed up regularly?",
      a: "Daily automated backups help ensure your critical data is safe and can be restored quickly whenever needed.",
    },
    {
      id: "p5",
      q: "Do you provide 24/7 support?",
      a: "Yes, our support team is available around the clock to assist with technical issues, maintenance, and service requests.",
    },
  ];

  return (
    <section id="faq" className="py-5" style={{ backgroundColor: "#fff" }}>
      <Container className="py-5">
        {/* 1. Header & Contact Buttons */}
        <div className="text-center mb-5">
          <h2 className="fw-bold text-dark mb-3">Frequently Asked Questions</h2>
          <p
            className="text-secondary mx-auto mb-4 small"
            style={{ maxWidth: "600px", color: "#878a99" }}
          >
            If you can not find answer to your question in our FAQ, you can
            always contact us or email us. We will answer you shortly!
          </p>

          <div className="d-flex justify-content-center align-items-center gap-3">
            <Button
              style={{ backgroundColor: "#405189", borderColor: "#405189" }}
              className="px-3 py-2 fw-medium shadow-sm btn-sm d-flex align-items-center"
              href="#support@tsmofficial.in"
            >
              <i className="bi bi-envelope me-2"></i> Email Us
            </Button>
            <Button
              style={{ backgroundColor: "#299cdb", borderColor: "#299cdb" }}
              className="px-3 py-2 fw-medium shadow-sm btn-sm d-flex align-items-center"
            >
              <i className="bi bi-twitter-x me-2"></i> Send Us Tweet
            </Button>
          </div>
        </div>

        {/* 2. Dual-Column Accordion Layout */}
        <Row className="g-5 mt-2">
          {/* Left Column: General Questions */}
          <Col lg={6}>
            <div className="d-flex align-items-center mb-4 text-dark">
              <i className="bi bi-question-circle text-info fs-4 me-2"></i>
              <h5 className="fw-bold mb-0">General Questions</h5>
            </div>

            <Accordion defaultActiveKey="none">
              {generalQuestions.map((item) => (
                <Accordion.Item
                  key={item.id}
                  eventKey={item.id}
                  className="mb-3 border rounded shadow-sm overflow-hidden bg-white"
                >
                  <Accordion.Header className="fw-semibold text-dark">
                    {item.q}
                  </Accordion.Header>
                  <Accordion.Body
                    className="text-secondary lh-base fs-6"
                    style={{ color: "#878a99" }}
                  >
                    {item.a}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Col>

          {/* Right Column: Privacy & Security */}
          <Col lg={6}>
            <div className="d-flex align-items-center mb-4 text-dark">
              <i className="bi bi-shield-check text-success fs-4 me-2"></i>
              <h5 className="fw-bold mb-0">Privacy & Security</h5>
            </div>

            <Accordion defaultActiveKey="none">
              {privacyQuestions.map((item) => (
                <Accordion.Item
                  key={item.id}
                  eventKey={item.id}
                  className="mb-3 border rounded shadow-sm overflow-hidden bg-white"
                >
                  <Accordion.Header className="fw-semibold text-dark">
                    {item.q}
                  </Accordion.Header>
                  <Accordion.Body
                    className="text-secondary lh-base fs-6"
                    style={{ color: "#878a99" }}
                  >
                    {item.a}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
